export default {
    businessMatchHome: {
      howCanIHelp: '今日はどのようなつながりをお手伝いしましょうか？',
      findIdealMatches: '理想的なビジネスパートナーを見つける',
      matchWithMembers: 'あなたのビジネスを成長させる {title} メンバーとマッチング',
      titleAll: 'すべて',
      stepOf: 'ステップ {current} / {total}',
      enterInfo: '情報を入力',
      inputKeywords: 'キーワードを入力',
      uploadPdf: 'PDFをアップロード',
      workEmail: '仕事用メール',
      websiteUrl: '会社のURL',
      linkedinUrl: 'LinkedIn URL',
      placeholderKeywords: '入力例：内装会社です。不動産仲介業者と提携できる方を探しています…',
      keywordsDesc: 'キーワードを入力して、特定のタイプのメンバーやビジネス機会を見つけます。',
      clickForExample: 'クイック例をクリック：',
      findMatches: 'マッチを見つける',
      switchToDemandKeywords: '需要キーワード検索に切り替え',
      switchToSupplyKeywords: '供給キーワード検索に切り替え',
      keywordsExample1: '高雄で刑事弁護士を探す',
      keywordsExample2: '吸汗速乾生地を扱えるスポーツウェア工場を探す',
      keywordsExample3: '会計サービスが必要な企業',
      keywordsExampleForCompany1: 'ラベルディスプレイまたは電子ペーパーを探す',
      keywordsExampleForCompany2: 'カスタマイズ産業用コンピュータを探す',
      keywordsExampleForCompany3: 'バーチャルリアリティアプリケーションベンダー',
      supplyKeywordsExample1: 'アジアでのTikTokライブプロモーション',
      supplyKeywordsExample2: 'ブランドとマーケティング幹部の橋渡し',
      supplyKeywordsExample3: '日本のクロスボーダー物流サービス',
      supplyKeywordsExample1ForCes: '販売代理店を探すスマートフォンアクセサリーメーカー',
      supplyKeywordsExample2ForCes: '消費者向け電子機器ODMサービスを提供するデザイン会社',
      supplyKeywordsExample3ForCes: 'ハードウェアパートナーを探すスマートホームインテグレーター',
      examples: {
        other: {
          commonSearches: {
            title: '一般的な検索',
            examples: [
              '私は住宅ローンを提供しており、不動産仲介業者を探しています',
              '私は清掃サービスを提供しており、不動産管理会社を通じて顧客の紹介を求めています',
              '会計サービスが必要な会社を探しています',
              '健康保険サービスを探しています',
              'ITコンサルタントを探しています',
              'シアトルのインテリアリノベーション会社を探しています'
            ]
          },
          newCustomerDevelopment: {
            title: '新規顧客開拓',
            examples: [
              '自動車ローンが必要な顧客を探しています',
              '写真撮影サービスが必要な顧客を探しています',
              '農産物の原材料が必要な顧客を探しています',
              '金融サービスが必要な顧客を探しています',
              '第三者決済やクロスボーダー決済ソリューションが必要な顧客を探しています'
            ]
          },
          professionalServices: {
            title: '専門サービス',
            examples: [
              '知的財産権の専門弁護士を探しています',
              'SNSマーケティングコンサルタントを探しています',
              '米国の不動産交換税法に精通した専門家を探しています',
              '台湾の金融法規に精通したコンプライアンスコンサルタントが必要です',
              'マンツーマンの運動コーチングサービスを探しています'
            ]
          },
          businessNetworking: {
            title: 'ビジネスネットワーク',
            examples: [
              '私は内装会社で、不動産仲介業者を通じて内装が必要な住宅所有者の紹介を求めています',
              '私は保険営業で、自動車販売店を通じて自動車保険が必要な車主の紹介を求めています',
              '私は貸切車両サービスを提供しており、旅行会社を通じて貸切車両サービスが必要な顧客を探しています',
              '私は公証サービスを提供しており、住宅ローン専門家を通じて顧客の紹介を求めています'
            ]
          },
          regionalBusinessMatching: {
            title: '地域ビジネスマッチング',
            examples: [
              '台北市のWebデザイン会社を探しています',
              '新北市のインテリアデザイナーを探しています',
              '高雄市の港運会社を探しています'
            ]
          }
        },
        track47: {
          productAndTechnology: {
            title: '製品・サービス・技術',
            examples: [
              'RAID 10設定をサポートするNASネットワークストレージデバイスを探しています',
              '100W急速充電をサポートするUSB4ケーブルを探しています',
              'データセンター用スイッチを探しています',
              '自動運転車両用のLiDARセンサーを探しています',
              'BCI（脳波インターフェース）とEEG（脳波図）技術を持つサプライヤーを探しています',
              '身体障害者と視覚障害者を支援するスマートデバイスを探しています',
              '国際デザイン賞受賞の消費者向け電子製品を探しています',
              'エンタメ・メディア分野の新技術を探しています'
            ]
          },
          solutions: {
            title: 'ソリューション',
            examples: [
              'スマートリテールソリューションを探しています',
              '5Gモジュールをサポートするエッジコンピューティングソリューションを探しています',
              'ESGカーボンマネジメントソリューションを探しています',
              'VRソリューションを探しています'
            ]
          },
          businessPartners: {
            title: 'ビジネスパートナー',
            examples: [
              'AIスタートアップアクセラレーターを探しています',
              '電気自動車技術パートナーを探しています',
              'ホログラム投影関連サプライチェーンパートナーを探しています',
              'ソリューション共同開発のためのフィンテック企業を探しています',
              'アグテック企業を探しています'
            ]
          },
          marketExpansion: {
            title: '市場開拓',
            examples: [
              'コンシューマー向け電子製品の販売代理店を探しています',
              '越境ECプラットフォームを探しています',
              'インタラクティブ展示・マルチメディアのプロモーションパートナーを探しています'
            ]
          },
          mediaMarketing: {
            title: 'メディア・マーケティング',
            examples: [
              '業界ニュースを報道するメディアを探しています',
              'テックポッドキャストのコラボレーションを探しています',
              '統合マーケティングのための国際広告代理店を探しています'
            ]
          }
        },
        track8: {
          franchiseExamples: {
            title: 'フランチャイズ例',
            examples: [
              'デジタルマーケティングとソーシャルメディア管理サービスが必要です',
              '従業員研修と認証システムが必要です',
              '立地評価と建設コスト管理サービスが必要です',
              'フランチャイズ融資サービスを提供しています',
              'マーケティングサービスプロバイダーで、データ分析とマーケティング自動化技術が必要です'
            ]
          }
        }
      },
      uploadYourFile: 'ファイルをアップロード',
      dragPdfHere: 'PDFファイルをここにドラッグ＆ドロップ',
      releaseToUpload: 'ドロップしてアップロード',
      orClickButton: 'または下のボタンをクリックしてファイルを選択',
      selectFile: 'ファイルを選択',
      changeFile: 'ファイルを変更',
      clickToChange: '下のボタンをクリックしてファイルを変更',
      uploadPdfDescription: 'PDFをアップロード（例：GAINsフォーム）して、協力できるメンバーを見つけます。',
      workEmailDescription: '会社のメールを入力して、あなたのサービスや製品を必要とする可能性のあるメンバーを見つけます。',
      websiteUrlDescription: '会社のURLを入力して、あなたのサービスや製品を必要とする可能性のあるメンバーを見つけます。',
      linkedInUrlDescription: 'LinkedIn URLを入力して、ネットワークを構築できるメンバーを見つけます。',
      onboardingDialog: {
        title: 'クイックプロフィール設定',
        description: 'この情報は、最適なビジネスパートナーを見つけ、ソーシャル体験を向上させるのに役立ちます。',
        descriptionPage2: 'プロフィールを完成させる',
        yourNameLabel: 'お名前',
        titleLabel: '役職',
        jobTitleLabel: '職種',
        emailLabel: 'メール',
        phoneLabel: '電話番号',
        industryLabel: '業界',
        bioLabel: '自己紹介',
        companyNameLabel: '会社名',
        companyWebsiteLabel: '会社のウェブサイト',
        websiteUsageHint: 'ウェブサイトを使用してビジネスをより理解します。',
        nextStep: '次へ',
        previousStep: '前へ',
        complete: '完了',
        completeButton: '完了して分析',
        addMoreDetailsLater: '後でプロフィールに詳細を追加できます'
      },
      snackbar: {
        closeButton: '閉じる'
      },
      profileReminderSnackbar: {
        message: 'プロフィールを完成させて、最適なマッチングを！',
        completeNow: '今すぐ完成 →'
      },
      matchingProcess: {
        title: 'マッチング中',
        whatIsNamecardDoing: 'Namecard.aiは何をしていますか？',
        analysisDescription: 'Namecard.aiがデータを分析し、理想的なパートナーとマッチングし、つながる理由と重要なトピックを提供します。'
      },
      validation: {
        personalEmailError: '個人または一時的なメールアドレスではなく、会社のメールアドレスを使用してください。',
        invalidEmailError: '有効なメールアドレスを使用してください',
        invalidLinkedInUrlError: 'https://www.linkedin.com/in/ で始まる有効なLinkedIn URLを使用してください',
        invalidUrlError: '有効なURLを使用してください',
        pdfOnlyError: 'PDFファイルのみアップロードしてください'
      },
      analyzing: '分析中',
      progressStatus: {
        analyzingRequest: 'リクエストを分析中...',
        searchingExhibitors: '出展企業を検索中...',
        smartMatching: 'スマートマッチング中...',
        generatingResults: '結果を生成中...'
      },
      errors: {
        pdfUploadFailed: 'PDFのアップロードに失敗しました。もう一度お試しください。',
        openaiUnavailable: 'OpenAIサービスは現在利用できません。後でもう一度お試しください。',
        fetchMatchFailed: '問題が発生しました。もう一度お試しください。',
        emptyQueryError: 'ドキュメントの内容を読み取ることができません。ファイルにパスワード保護がないことを確認するか、分析用により多くのテキスト内容を含むドキュメントをアップロードしてください。',
        incompleteUrlError: '完全なURLを入力して、再度検索してください'
      },
      namecardAi: 'Namecard.ai',
      trackUserGroups: {
        track5: 'BNI台湾の新規ユーザー',
        track6: 'BNIアメリカの新規ユーザー',
        track7: 'Computexの新規ユーザー',
        track0: 'Namecardプラットフォームの新規ユーザー'
      },
      detailDrawer: {
        matchReasonTitle: 'マッチング理由'
      }
    },
    businessMatchContent: {
      title: 'コラボレーション項目',
      matchingProcess: {
        title: 'マッチング',
        whatIsNamecardDoing: 'Namecard.aiは何をしていますか？',
        analysisDescription: 'Namecard.aiはあなたのデータを分析し、理想的なパートナーとマッチングし、接続する理由と重要な話題を提供します。'
      },
      snackbar: {
        closeButton: '閉じる'
      },
      errors: {
        openaiUnavailable: 'OpenAIサービスは現在利用できません。後でもう一度お試しください。',
        fetchMatchFailed: '問題が発生しました。もう一度お試しください。'
      },
      addButton: 'コラボレーション項目を追加',
      selectAllButton: 'すべて選択',
      deselectAllButton: 'すべて選択解除',
      startMatching: 'マッチングを開始',
      notCategorized: '未分類',
      originalQueryPrefix: '元のクエリ: ',
      demandLabel: '探し中',
      supplyLabel: '提供中',
      reasonPrefix: '理由: ',
      deleteDialog: {
        title: '削除確認',
        message: 'このオプションを削除してもよろしいですか？',
        cancelButton: 'キャンセル',
        confirmButton: '確認'
      },
      addDialog: {
        title: 'コラボレーション項目を追加',
        inputLabel: 'キーワードを入力してください',
        cancelButton: 'キャンセル',
        addButton: '追加'
      },
      noOptionsTitle: 'コラボレーション項目を識別できません',
      noOptionsMessage: 'システムは提供された情報から明確なコラボレーション項目を識別できませんでした。前のページに戻って、より具体的なキーワードやコンテンツを入力してください。',
      backToHomeButton: '戻って再入力',
      invalidQueryDialog: {
        title: '無効なクエリ',
        message: 'あなたのクエリは新しいコラボレーション項目を生成しませんでした。より具体的または異なるキーワードを入力してみてください。',
        confirmButton: 'OK'
      }
    },
    businessMatchHomePlaceholders: {
      workEmail: 'john@company.com',
      website: 'https://www.company.com',
      linkedin: 'https://www.linkedin.com/in/john',
      name: 'お名前を入力',
      jobTitle: '役職を入力',
      companyName: '会社名を入力',
      websiteShort: 'www.example.com',
      email: 'メールアドレスを入力してください',
      phone: '電話番号を入力してください',
      industry: '業界を選択してください（最大5つ）',
      searchIndustry: '業界を検索...',
      bio: 'ご自身と専門的な経歴について教えてください...'
    },
    avatarMenu: {
      myProfile: 'プロフィール',
      matches: 'マッチング',
      supplyDemand: 'コラボレーション項目',
      myContacts: 'コンタクト',
      emailSent: '送信済みメール',
      chatChannels: 'チャットチャンネル',
      signOut: 'ログアウト',
      freePlan: {
        title: '無料プラン',
        description: '30日間の無料トライアルを開始！データを入力してプレミアム機能をアンロック。',
        startTrialButton: '無料トライアルを開始'
      },
      freeTrial: {
        title: '無料トライアル',
        daysLeft: '残り {days} 日',
        description: 'トライアルを30日間延長！フィードバックをお聞かせください。',
        giveFeedbackButton: 'フィードバックを送信',
        upgradeButton: 'アップグレード'
      },
      premiumMember: {
        title: 'プレミアム会員',
        proBadge: 'Pro',
        description: 'すべてのプレミアム機能をお楽しみください'
      },
      feedbackDialog: {
        title: 'お客様のご意見を大切にしています',
        description: 'より良いサービスを提供するため、製品改善のご提案をお聞かせください。',
        feedbackLabel: 'ご提案',
        feedbackRequired: '*',
        feedbackPlaceholder: '改善のご提案をご記入ください...',
        feedbackHelpText: 'お客様のフィードバックは製品機能の改善に役立ちます。',
        cancelButton: 'キャンセル',
        submitButton: 'フィードバックを送信'
      }
    },
    businessMatchResults: {
      matchScore: 'マッチ度',
      explicitMatches: '明確な需要マッチのみ表示',
      aiRecommendations: 'AI推奨のみ表示',
      explicitMatchesLabel: '直接マッチ',
      explicitMatchesTooltip: 'あなたのニーズや提供内容と直接一致する結果を表示',
      aiRecommendationsLabel: 'AI推奨',
      aiRecommendationsTooltip: 'AIが分析した潜在的なビジネスパートナーを推奨',
      showAll: 'すべて表示',
      filterTitle: 'フィルター',
      clearAllButton: 'すべてクリア',
      locationFilterLabel: '国',
      seeFewerOptions: '少ないオプションを表示',
      seeAllOptions: 'すべてのオプションを表示',
      industryFilterLabel: '業界',
      matchDirectionFilterLabel: 'マッチング方向',
      matchQueryFilterLabel: 'マッチングクエリ',
      typeFilterLabel: '役割',
      regionFilterLabel: '地域',
      directionDemandToSupply: '需要マッチング',
      directionSupplyToDemand: '供給マッチング',
      directionBidirectional: '双方向マッチング',
      noMoreResults: 'これ以上の結果はありません',
      applyFilterButton: 'フィルターを適用',
      pageTitle: 'あなたのパーソナライズされたマッチ',
      pageTitleMobile: 'あなたのパーソナライズされたマッチ',
      pageSubtitle: 'あなたのニーズに基づいて、潜在的なビジネスパートナーのリストを生成しました。条件を手動で調整してリアルタイムで結果を調整できます。',
      shareButton: '共有',
      whatYourQuery: 'あなたのマッチングクエリ:',
      whyMatchThis: 'マッチング理由:',
      savedButton: '保存済み',
      saveContactButton: '連絡先を保存',
      profileReminder: {
        title: 'プロフィールを完成させて1ヶ月無料プレミアムを取得',
        description: 'プロフィールを記入してより多くの機能をアンロック',
        benefit1: '100件の検索結果を表示',
        benefit2: 'より高い露出機会を獲得',
        benefit3: '推奨結果の連絡先情報を表示',
        laterButton: '後で',
        goToProfileButton: 'プロフィールへ'
      },
      unlockMoreResults: 'より多くの結果をアンロック',
      completeProfileToSeeMore: 'プロフィールを完成させてより多くの結果を見る',
      platformUser: 'プラットフォームユーザー',
      learnMoreButton: '詳細を見る',
      noResultsFoundTitle: '結果が見つかりません。',
      noResultsFoundSubtitle: '別のソースまたはキーワードでもう一度お試しください。',
      retryButton: '再試行',
      detailDrawer: {
        companyWebsiteTitle: '会社のウェブサイト',
        descriptionTitle: '説明',
        iHaveTitle: 'オファリング',
        iWantTitle: 'ニーズ',
        matchSummaryTitle: 'マッチング理由',
        contactTitle: '連絡先',
        savedToContactsButton: '連絡先に保存済み',
        emailContactButton: '会議をリクエスト',
        sendEmailButton: 'メールを送信',
        bniMemberDetailButton: 'BNIメンバー詳細',
        connectButton: '連絡',
        connectedButton: '連絡済み',
        alreadyContacted: 'すでにこの方に連絡済みです',
        messageButton: 'メッセージ',
        emailSentAndAddedToNetwork: 'メールを送信し、ネットワークに追加しました',
        emailSendFailed: 'メールの送信に失敗しました',
        addedToContactList: '連絡先リストに追加されました。チャットチャンネルで会話を開始してください。',
        addedToContacts: '連絡先に追加されました。',
        chatChannel: 'チャットチャンネル',
        toStartConversation: 'をクリックして会話を開始してください。',
        contactSavedAndEmailSent: '連絡先への追加とメール送信に成功しました',
        contactSaved: '連絡先に追加しました',
        emailSent: 'メールが正常に送信されました',
        connectSuccessConnected: '接続しました。',
        connectSuccessStartConversation: '会話を開始',
        connectSuccessAddedTo: '',
        connectSuccessMyContacts: 'マイコンタクト',
        connectSuccessNotifiedByEmail: 'に追加されました — メールで通知されました',
        connectSuccessConnectedAddedTo: '接続しました。',
        connectFailed: '接続に失敗しました。もう一度お試しください。',
        incompleteProfile: '接続する前にプロフィールを完成させてください。',
        goToProfile: 'プロフィールへ'
      },
      sharingDialog: {
        title: '公開リンクを作成しました',
        description: 'マッチング用の公開リンクを作成しました。このリンクを持つ人は誰でもこれらのマッチを表示できます。'
      },
      emailDialog: {
        sendEmailTo: '{name}にメールを送信',
        subjectLabel: '件名',
        messageLabel: 'メッセージ',
        setUpAvailabilityButton: '利用可能時間を設定',
        cancelButton: 'キャンセル',
        sendEmailButton: 'メールを送信'
      },
      emailSuccessDialog: {
        title: 'メールが正常に送信されました！',
        descriptionLine1: '{name}に紹介リクエストを送信しました。',
        descriptionLine2: 'Namecard.aiが両者の会議時間の調整をお手伝いします。',
        viewSentEmailsButton: '送信済みメールを表示',
        doneButton: '完了'
      },
      sendEmailDialog: {
        title: '{name}にメールを送信',
        subjectLabel: '件名',
        subjectPlaceholder: 'メールの件名を入力してください',
        contentLabel: 'メール本文',
        contentPlaceholder: '受信者へのメッセージを入力してください',
        systemNoteLabel: '以下のテキストがメールに含まれます',
        sharingNote: '以下は私の名刺共有リンクです。ご確認いただき、ビジネス協力の機会についてご連絡ください：',
        cancelButton: 'キャンセル',
        sendButton: '送信'
      }
    },
    businessMatchSavedContacts: {
      matchScore: 'マッチ度',
      platformUser: 'プラットフォームユーザー',
      whatYourQuery: 'あなたのマッチングクエリ:',
      whyMatchThis: 'マッチング理由:',
      viewMoreButton: 'もっと見る',
      learnMoreButton: '詳細を見る',
      noSavedContactsTitle: 'ネットワークの構築を開始',
      noSavedContactsSubtitle: '興味のある連絡先を保存すると、ここに表示されます。',
      findContactsButton: '連絡先を探す',
      noMoreResults: 'これ以上の結果はありません',
      detailDrawer: {
        descriptionTitle: '説明',
        iHaveTitle: 'オファリング',
        iWantTitle: 'ニーズ',
        matchSummaryTitle: 'マッチング理由',
        contactTitle: '連絡先',
        companyWebsiteTitle: '会社のウェブサイト',
        bniMemberDetailButton: 'BNIメンバー詳細',
        removeFromContactsButton: '連絡先から削除',
        emailContactButton: '会議をリクエスト',
        sendEmailButton: 'メールを送信',
        addedToContacts: '連絡先に追加されました。',
        chatChannel: 'チャットチャンネル',
        toStartConversation: 'をクリックして会話を開始してください。'
      },
      sendEmailDialog: {
        title: '{name}にメールを送信',
        subjectLabel: '件名',
        subjectPlaceholder: 'メールの件名を入力してください',
        contentLabel: 'メール本文',
        contentPlaceholder: '受信者へのメッセージを入力してください',
        systemNoteLabel: '以下のテキストがメールに含まれます',
        sharingNote: '以下は私の名刺共有リンクです。ご確認いただき、ビジネス協力の機会についてご連絡ください：',
        cancelButton: 'キャンセル',
        sendButton: '送信'
      },
      emailDialog: {
        sendEmailTo: '{name}にメールを送信',
        subjectLabel: '件名',
        messageLabel: 'メッセージ',
        setUpAvailabilityButton: '利用可能時間を設定',
        cancelButton: 'キャンセル',
        sendEmailButton: 'メールを送信'
      },
      emailSuccessDialog: {
        title: 'メールが正常に送信されました！',
        descriptionLine1: '{name}に紹介リクエストを送信しました。',
        descriptionLine2: 'Namecard.aiが両者の会議時間の調整をお手伝いします。',
        viewSentEmailsButton: '送信済みメールを表示',
        doneButton: '完了'
      },
      deleteDialog: {
        confirmation: '{name}を連絡先から削除してもよろしいですか？',
        cancelButton: 'キャンセル',
        deleteButton: '削除'
      }
    },
    businessMatchSharingMatchResults: {
      pageTitle: '厳選されたビジネスマッチを探索する。',
      pageSubtitle: '誰かがこれらのビジネスコネクションがあなたにとって価値があると考えました。厳選された潜在的なパートナーリストをご覧ください。',
      whatYourQuery: 'あなたのマッチングクエリ:',
      whyMatchThis: 'マッチング理由:',
      matchScore: 'マッチ度',
      platformUser: 'プラットフォームユーザー',
      completeProfileToSeeMore: 'プロフィールを完成させてより多くの結果を表示',
      savedButton: '保存済み',
      saveContactButton: '連絡先を保存',
      learnMoreButton: '詳細を見る',
      noResultsFoundTitle: '結果が見つかりません。',
      noResultsFoundSubtitle: '別のソースまたはキーワードでもう一度お試しください。',
      retryButton: '再試行',
      detailDrawer: {
        descriptionTitle: '説明',
        iHaveTitle: 'オファリング',
        iWantTitle: 'ニーズ',
        matchSummaryTitle: 'マッチング理由',
        contactTitle: '連絡先',
        savedToContactsButton: '連絡先に保存済み',
        emailContactButton: '会議をリクエスト',
        companyWebsiteTitle: '会社のウェブサイト',
        bniMemberDetailButton: 'BNIメンバー詳細',
        addedToContacts: '連絡先に追加されました。',
        chatChannel: 'チャットチャンネル',
        toStartConversation: 'をクリックして会話を開始してください。'
      },
      emailDialog: {
        sendEmailTo: '{name}にメールを送信',
        subjectLabel: '件名',
        messageLabel: 'メッセージ',
        setUpAvailabilityButton: '利用可能時間を設定',
        cancelButton: 'キャンセル',
        sendEmailButton: 'メールを送信'
      },
      emailSuccessDialog: {
        title: 'メールが正常に送信されました！',
        descriptionLine1: '{name}に紹介リクエストを送信しました。',
        descriptionLine2: 'Namecard.aiが両者の会議時間の調整をお手伝いします。',
        viewSentEmailsButton: '送信済みメールを表示',
        doneButton: '完了'
      },
      pageTitleMobile: 'あなたのパーソナライズされたマッチ',
      noMoreResults: 'これ以上の結果はありません'
    },
    nonLoginBusinessMatch: {
      findIdealMatches: '理想的なビジネスパートナーを見つける',
      matchWithMembers: 'あなたのビジネスを成長させる {title} メンバーとマッチング',
      matchWithMembersMobile: 'あなたのビジネスを成長させる {title} メンバーとマッチング',
      titleAll: 'すべて',
      stepOf: 'ステップ {current} / {total}',
      enterInfo: '情報を入力',
      inputKeywords: 'キーワードを入力',
      uploadPdf: 'PDFをアップロード',
      workEmail: '仕事用メール',
      websiteUrl: '会社のURL',
      linkedinUrl: 'LinkedIn URL',
      placeholderKeywords: '入力例：内装会社です。不動産仲介業者と提携できる方を探しています…',
      keywordsDesc: 'キーワードを入力して、特定のタイプのメンバーやビジネス機会を見つけます。',
      clickForExample: 'クイック例をクリック：',
      findMatches: 'マッチを見つける',
      switchToDemandKeywords: '需要キーワード検索に切り替え',
      switchToSupplyKeywords: '供給キーワード検索に切り替え',
      keywordsExample1: '高雄で刑事弁護士を探す',
      keywordsExample2: '吸汗速乾生地を扱えるスポーツウェア工場を探す',
      keywordsExample3: '会計サービスが必要な企業',
      keywordsExampleForCompany1: 'ラベルディスプレイまたは電子ペーパーを探す',
      keywordsExampleForCompany2: 'カスタマイズ産業用コンピュータを探す',
      keywordsExampleForCompany3: 'バーチャルリアリティアプリケーションベンダー',
      supplyKeywordsExample1: 'アジアでのTikTokライブプロモーション',
      supplyKeywordsExample2: 'ブランドとマーケティング幹部の橋渡し',
      supplyKeywordsExample3: '日本のクロスボーダー物流サービス',
      supplyKeywordsExample1ForCes: '販売代理店を探すスマートフォンアクセサリーメーカー',
      supplyKeywordsExample2ForCes: '消費者向け電子機器ODMサービスを提供するデザイン会社',
      supplyKeywordsExample3ForCes: 'ハードウェアパートナーを探すスマートホームインテグレーター',
      examples: {
        other: {
          commonSearches: {
            title: '一般的な検索',
            examples: [
              '私は住宅ローンを提供しており、不動産仲介業者を探しています',
              '私は清掃サービスを提供しており、不動産管理会社を通じて顧客の紹介を求めています',
              '会計サービスが必要な会社を探しています',
              '健康保険サービスを探しています',
              'ITコンサルタントを探しています',
              'シアトルのインテリアリノベーション会社を探しています'
            ]
          },
          newCustomerDevelopment: {
            title: '新規顧客開拓',
            examples: [
              '自動車ローンが必要な顧客を探しています',
              '写真撮影サービスが必要な顧客を探しています',
              '農産物の原材料が必要な顧客を探しています',
              '金融サービスが必要な顧客を探しています',
              '第三者決済やクロスボーダー決済ソリューションが必要な顧客を探しています'
            ]
          },
          professionalServices: {
            title: '専門サービス',
            examples: [
              '知的財産権の専門弁護士を探しています',
              'SNSマーケティングコンサルタントを探しています',
              '米国の不動産交換税法に精通した専門家を探しています',
              '台湾の金融法規に精通したコンプライアンスコンサルタントが必要です',
              'マンツーマンの運動コーチングサービスを探しています'
            ]
          },
          businessNetworking: {
            title: 'ビジネスネットワーク',
            examples: [
              '私は内装会社で、不動産仲介業者を通じて内装が必要な住宅所有者の紹介を求めています',
              '私は保険営業で、自動車販売店を通じて自動車保険が必要な車主の紹介を求めています',
              '私は貸切車両サービスを提供しており、旅行会社を通じて貸切車両サービスが必要な顧客を探しています',
              '私は公証サービスを提供しており、住宅ローン専門家を通じて顧客の紹介を求めています'
            ]
          },
          regionalBusinessMatching: {
            title: '地域ビジネスマッチング',
            examples: [
              '台北市のWebデザイン会社を探しています',
              '新北市のインテリアデザイナーを探しています',
              '高雄市の港運会社を探しています'
            ]
          }
        },
        track47: {
          productAndTechnology: {
            title: '製品・サービス・技術',
            examples: [
              'RAID 10設定をサポートするNASネットワークストレージデバイスを探しています',
              '100W急速充電をサポートするUSB4ケーブルを探しています',
              'データセンター用スイッチを探しています',
              '自動運転車両用のLiDARセンサーを探しています',
              'BCI（脳波インターフェース）とEEG（脳波図）技術を持つサプライヤーを探しています',
              '身体障害者と視覚障害者を支援するスマートデバイスを探しています',
              '国際デザイン賞受賞の消費者向け電子製品を探しています',
              'エンタメ・メディア分野の新技術を探しています'
            ]
          },
          solutions: {
            title: 'ソリューション',
            examples: [
              'スマートリテールソリューションを探しています',
              '5Gモジュールをサポートするエッジコンピューティングソリューションを探しています',
              'ESGカーボンマネジメントソリューションを探しています',
              'VRソリューションを探しています'
            ]
          },
          businessPartners: {
            title: 'ビジネスパートナー',
            examples: [
              'AIスタートアップアクセラレーターを探しています',
              '電気自動車技術パートナーを探しています',
              'ホログラム投影関連サプライチェーンパートナーを探しています',
              'ソリューション共同開発のためのフィンテック企業を探しています',
              'アグテック企業を探しています'
            ]
          },
          marketExpansion: {
            title: '市場開拓',
            examples: [
              'コンシューマー向け電子製品の販売代理店を探しています',
              '越境ECプラットフォームを探しています',
              'インタラクティブ展示・マルチメディアのプロモーションパートナーを探しています'
            ]
          },
          mediaMarketing: {
            title: 'メディア・マーケティング',
            examples: [
              '業界ニュースを報道するメディアを探しています',
              'テックポッドキャストのコラボレーションを探しています',
              '統合マーケティングのための国際広告代理店を探しています'
            ]
          }
        },
        track8: {
          franchiseExamples: {
            title: 'フランチャイズ例',
            examples: [
              'デジタルマーケティングとソーシャルメディア管理サービスが必要です',
              '従業員研修と認証システムが必要です',
              '立地評価と建設コスト管理サービスが必要です',
              'フランチャイズ融資サービスを提供しています',
              'マーケティングサービスプロバイダーで、データ分析とマーケティング自動化技術が必要です'
            ]
          }
        }
      },
      uploadYourFile: 'ファイルをアップロード',
      dragPdfHere: 'PDFファイルをここにドラッグ＆ドロップ',
      releaseToUpload: 'ドロップしてアップロード',
      orClickButton: 'または下のボタンをクリックしてファイルを選択',
      selectFile: 'ファイルを選択',
      changeFile: 'ファイルを変更',
      clickToChange: '下のボタンをクリックしてファイルを変更',
      uploadPdfDescription: 'PDFをアップロード（例：GAINsフォーム）して、協力できるメンバーを見つけます。',
      workEmailDescription: '会社のメールを入力して、あなたのサービスや製品を必要とする可能性のあるメンバーを見つけます。',
      websiteUrlDescription: '会社のURLを入力して、あなたのサービスや製品を必要とする可能性のあるメンバーを見つけます。',
      linkedInUrlDescription: 'LinkedIn URLを入力して、ネットワークを構築できるメンバーを見つけます。',
      membersDirectoryTitle: 'メンバーディレクトリ',
      trustedByTitle: 'お客様から信頼されています',
      snackbar: {
        closeButton: '閉じる'
      },
      matchingProcess: {
        title: 'マッチング中',
        whatIsNamecardDoing: 'Namecard.aiは何をしていますか？',
        analysisDescription: 'Namecard.aiがデータを分析し、理想的なパートナーとマッチングし、つながる理由と重要なトピックを提供します。'
      },
      validation: {
        personalEmailError: '個人または一時的なメールアドレスではなく、会社のメールアドレスを使用してください。',
        invalidEmailError: '有効なメールアドレスを使用してください',
        invalidLinkedInUrlError: 'https://www.linkedin.com/in/ で始まる有効なLinkedIn URLを使用してください',
        invalidUrlError: '有効なURLを使用してください',
        pdfOnlyError: 'PDFファイルのみアップロードしてください'
      },
      analyzing: '分析中',
      progressStatus: {
        analyzingRequest: 'リクエストを分析中...',
        searchingExhibitors: '出展企業を検索中...',
        smartMatching: 'スマートマッチング中...',
        generatingResults: '結果を生成中...'
      },
      errors: {
        pdfUploadFailed: 'PDFのアップロードに失敗しました。もう一度お試しください。',
        openaiUnavailable: 'OpenAIサービスは現在利用できません。後でもう一度お試しください。',
        fetchMatchFailed: 'マッチの取得中にエラーが発生しました。もう一度お試しください。',
        emptyQueryError: 'ドキュメントの内容を読み取ることができません。ファイルにパスワード保護がないことを確認するか、分析用により多くのテキスト内容を含むドキュメントをアップロードしてください。'
      },
      namecardAi: 'Namecard.ai'
    },
    nonLoginBusinessMatchPlaceholders: {
      workEmail: 'john@company.com',
      website: 'https://www.company.com',
      linkedin: 'https://www.linkedin.com/in/john'
    },
    timeCollection: {
      setTitle: '定期的な利用可能時間を設定',
      timezoneQuestion: 'どのタイムゾーンで作業しますか？',
      quickTemplatesTitle: 'クイックテンプレート',
      showBusinessHoursButton: '営業時間を表示',
      showAllHoursButton: 'すべての時間を表示',
      setWeeklyAvailabilityTitle: '週間利用可能時間を設定',
      dragInstructionTooltip: 'クリック＆ドラッグして複数の時間帯を一度に選択または選択解除します。',
      dragInstructionFooter: 'クリック＆ドラッグして複数の時間帯を一度に選択',
      meetingDurationQuestion: '会議の長さはどのくらいですか？',
      repeatWeeksQuestion: 'この設定を何週間繰り返しますか？',
      repeatUntilDate: 'あなたの利用可能時間は {date} まで繰り返されます',
      saveButton: '時間投票会議を作成',
      days: {
        monday: '月曜日',
        tuesday: '火曜日',
        wednesday: '水曜日',
        thursday: '木曜日',
        friday: '金曜日',
        saturday: '土曜日',
        sunday: '日曜日'
      },
      templates: {
        business: '営業時間（午前9時〜午後5時、月〜金）',
        extended: '延長時間（午前8時〜午後8時、月〜金）',
        weekends: '週末のみ（午前10時〜午後4時、土〜日）',
        mornings: '午前のみ（午前8時〜正午12時、月〜金）',
        afternoons: '午後のみ（午後1時〜午後5時、月〜金）',
        evenings: '夜のみ（午後6時〜午後9時、月〜金）'
      },
      meetingDurations: {
        minutes: '{count} 分'
      },
      repeatWeeks: {
        weeks: '{count} 週間',
        month: '1ヶ月（4週間）',
        months: '{monthCount}ヶ月（{count}週間）'
      }
    },
    nonLoginBusinessMatchResults: {
      explicitMatches: '明確な需要マッチのみ表示',
      aiRecommendations: 'AI推奨のみ表示',
      explicitMatchesLabel: '直接マッチ',
      explicitMatchesTooltip: 'あなたのニーズや提供内容と直接一致する結果を表示',
      aiRecommendationsLabel: 'AI推奨',
      aiRecommendationsTooltip: 'AIが分析した潜在的なビジネスパートナーを推奨',
      showAll: 'すべて表示',
      loginError: 'ログインプロセスを完了するには、モバイルブラウザでこのページを開いてください。',
      filterTitle: 'フィルター',
      clearAllButton: 'すべてクリア',
      locationFilterLabel: '場所',
      seeFewerOptions: '少ないオプションを表示',
      seeAllOptions: 'すべてのオプションを表示',
      industryFilterLabel: '業界',
      matchDirectionFilterLabel: 'マッチング方向',
      matchQueryFilterLabel: 'マッチングクエリ',
      typeFilterLabel: '役割',
      regionFilterLabel: '地域',
      applyFilterButton: 'フィルターを適用',
      pageTitle: 'あなたのパーソナライズされたマッチ',
      pageSubtitle: 'あなたのニーズに基づいて、潜在的なビジネスパートナーのリストを生成しました。条件を手動で調整してリアルタイムで結果を調整できます。',
      shareButton: '共有',
      whatYourQuery: 'あなたのマッチングクエリ:',
      whyMatchThis: 'マッチング理由:',
      platformUser: 'プラットフォームユーザー',
      loginToSaveContactButton: '連絡',
      loginToViewMore: 'ログイン/登録',
      learnMoreButton: '詳細を見る',
      noResultsFoundTitle: '結果が見つかりません。',
      noResultsFoundSubtitle: '別のソースまたはキーワードでもう一度お試しください。',
      retryButton: '再試行',
      matchScore: 'マッチ度',
      directionDemandToSupply: '需要マッチング',
      directionSupplyToDemand: '供給マッチング',
      directionBidirectional: '双方向',
      noMoreResults: 'これ以上の結果はありません',
      detailDrawer: {
        descriptionTitle: '説明',
        iHaveTitle: 'オファリング',
        iWantTitle: 'ニーズ',
        matchSummaryTitle: 'マッチング理由',
        companyWebsiteTitle: '会社のウェブサイト',
        contactTitle: '連絡先',
        loginToSaveContactButton: '連絡',
        loginToViewContactsButton: '連絡先を表示',
        bniMemberDetailButton: 'BNIメンバー詳細'
      },
      loginPromptDialog: {
        title: 'ログインして繋がろう！',
        message: 'ログイン/登録すると、連絡先の保存、完全な連絡先情報の表示、その他の専用機能をお楽しみいただけます。',
        refineTitle: 'より多くのプレミアムマッチを解除',
        refineMessage: 'ログイン/登録してより多くのプレミアムマッチを解除し、完全な連絡先情報を表示し、専用機能をお楽しみください。',
        loginButton: '今すぐログイン/登録',
        cancelButton: '後で'
      },
      sharingDialog: {
        title: '公開リンクを作成しました',
        description: 'マッチング用の公開リンクを作成しました。このリンクを持つ人は誰でもこれらのマッチを表示できます。'
      },
      pageTitleMobile: 'あなたのパーソナライズされたマッチ'
    },
    nonLoginSharingMatchResults: {
      pageTitle: '誰かがこれらのビジネスコネクションをあなたと共有しました。連絡先情報にアクセスするにはログインしてください。',
      pageSubtitle: '誰かがこれらのビジネスコネクションがあなたにとって価値があると考えました。厳選された潜在的なパートナーリストをご覧ください。',
      whatYourQuery: 'あなたのマッチングクエリ:',
      whyMatchThis: 'マッチング理由:',
      savedButton: '連絡済み',
      saveContactButton: '連絡',
      loginToSaveContactButton: '連絡',
      learnMoreButton: '詳細を見る',
      noResultsFoundTitle: '結果が見つかりません。',
      noResultsFoundSubtitle: '別のソースまたはキーワードでもう一度お試しください。',
      retryButton: '再試行',
      detailDrawer: {
        descriptionTitle: '説明',
        iHaveTitle: 'オファリング',
        iWantTitle: 'ニーズ',
        matchSummaryTitle: 'マッチング理由',
        contactTitle: '連絡先',
        companyWebsiteTitle: '会社ウェブサイト',
        savedToContactsButton: '連絡済み',
        loginToSaveContactButton: '連絡',
      },
      loginToViewMore: 'ログイン/登録',
      loginError: 'ログインプロセスを完了するには、モバイルブラウザでこのページを開いてください。',
      matchScore: 'マッチスコア',
      platformUser: 'プラットフォームユーザー',
      pageTitleMobile: 'あなたのパーソナライズされたマッチ',
      whatCompanyOffersMobile: 'この会社が提供するもの：',
      whatPersonOffersMobile: 'この人が提供するもの：',
      noMoreResults: 'これ以上の結果はありません'
    },
    businessMatchProfile: {
      pageTitle: 'より良いマッチング結果のためにプロフィールを編集',
      pageSubtitle: 'あなたのプロフィールはNamecard.aiのマッチング提案の基礎であり、他のユーザーには公開されません。直接編集するか、新しいソースをアップロードしてAIが要約できます。',
      editButton: '編集',
      uploadSourceButton: 'ソースをアップロード',
      sourceLabel: 'ソース',
      viewAction: '表示',
      deleteAction: '削除',
      lastUpdatedLabel: '最終更新',
      getYourMatchesButton: 'マッチを取得',
      pageTitleMobile: 'より良いマッチング結果のためにプロフィールを編集',
      pageSubtitleMobileTooltip: 'あなたのプロフィールはNamecard.aiのマッチング提案の基礎であり、他のユーザーには公開されません。直接編集するか、新しいソースをアップロードしてAIが要約できます。',
      historyButtonMobile: '履歴',
      editProfileButtonMobile: 'プロフィールを編集',
      feedbackHowsYourProfile: 'プロフィールはいかがですか？',
      feedbackLetUsKnow: '期待に応えているかお知らせください。',
      likeButton: 'いいね',
      dislikeButton: 'よくない',
      feedbackThanks: 'フィードバックありがとうございます！',
      discardChangesButton: '変更を破棄',
      saveButton: '保存',
      uploadSourceDialog: {
        title: 'ソースをアップロード',
        subtitle: '新しいソースをアップロードすると、Namecard.aiがそれらを分析してパーソナライズされたプロフィールを再生成します。',
        overwriteWarning: '注意：アップロードすると既存の記録が上書きされます。',
        addLinkedInTitle: 'LinkedInプロフィールURLを追加',
        learnMoreLink: '詳細を見る',
        shareWebsiteTitle: '会社のウェブサイトを共有',
        urlInformationGuideLink: 'URL情報ガイド',
        uploadMaterialsTitle: '会社資料をアップロード',
        selectPdfButton: 'PDFを選択してアップロード',
        pdfSupportHint: 'サポートされるファイルタイプ：PDF（最大10MB）',
        closeButton: '閉じる',
        insertButton: '挿入'
      },
      deleteSourceDialog: {
        title: 'これらのソースを削除してもよろしいですか？',
        subtitle: '削除後、Namecard.aiは利用可能な情報に基づいてプロフィールを再生成します。',
        closeButton: '閉じる',
        deleteButton: 'ソースを削除'
      },
      learnMoreDialog: {
        title: 'LinkedInプロフィールを共有する方法',
        step1Text: 'LinkedInプロフィールを公開に設定して、より良いマッチング結果のために情報にアクセスして分析できるようにします。',
        step1Link: 'プライバシー設定の調整方法を見る',
        step2Text: 'LinkedInプロフィールページにアクセスし、プロフィールURLをコピーして入力フィールドに貼り付けます。',
        backButton: '戻る'
      },
      urlInfoDialog: {
        title: 'URL情報ガイド',
        point1: 'ビジネスの内容を含むURLを入力',
        point2: 'https:// で始まる必要があります',
        point3: 'URLは公開アクセス可能である必要があります',
        point4: '会社のウェブサイト、製品ページ、プレスリリースなどを含めることができます。',
        point5: 'コンテンツを分析してビジネスを理解し、より良いマッチを作成します。',
        backButton: '戻る'
      },
      snackbar: {
        closeButton: '閉じる'
      },
      generatingProfileTitle: 'プロフィールを生成中',
      matchingTitle: 'マッチング中',
      urlHint: '前に "www" を追加する必要があるかもしれません',
      validation: {
        invalidLinkedInUrlError: 'https://www.linkedin.com/in/ で始まる有効なLinkedIn URLを使用してください',
        invalidUrlError: '有効なURLを使用してください',
        invalidPdfError: '有効なPDFを使用してください'
      },
      errors: {
        pdfUploadFailed: 'PDFのアップロードに失敗しました。もう一度お試しください。',
        maxSourcesExceeded: '最大10個のソースまでアップロードできます。',
        sourceLoadFailed: 'ソースの読み込みに失敗しました。URLを再度提供してください。',
        fetchMatchFailed: 'マッチの取得中にエラーが発生しました。もう一度お試しください。'
      },
      notifications: {
        profileUpdatedWithSource: 'プロフィールは提供された新しいソースで更新されました。',
        profileUpdated: 'プロフィールが更新されました',
        sourcesDeletedProfileUpdated: 'ソースが削除され、プロフィールが更新されました。',
        sourceDeleted: 'ソースが正常に削除されました。'
      }
    },
    userProfile: {
      myProfileTitle: 'プロフィール',
      analyzing: 'プロフィールを分析中',
      tabs: {
        basicInfo: '基本情報',
        suppliesAndDemands: '供給と需要',
        profilePreview: 'プロフィールプレビュー'
      },
      basicInfoSection: {
        title: '基本情報',
        profileStrength: 'プロフィール完成度：{value} %',
        fullNameLabel: 'フルネーム',
        fullNamePlaceholder: 'あなたのフルネーム',
        fullNameRequired: 'フルネームを入力してください',
        jobTitleLabel: '役職',
        jobTitlePlaceholder: 'あなたの役職',
        emailLabel: 'メールアドレス',
        emailPlaceholder: 'あなたのメールアドレス',
        phoneLabel: '電話番号',
        phonePlaceholder: 'あなたの連絡先電話番号',
        companyLabel: '会社',
        companyPlaceholder: '会社名',
        locationLabel: '場所',
        locationPlaceholder: '都市、国',
        industryLabel: '業界（最大5つ選択）',
        industryPlaceholder: '業界を選択...',
        industriesSelected: '{count}個の業界を選択',
        industriesSelectedCount: '{count}/5個の業界を選択',
        companyWebsiteLabel: '会社のウェブサイト',
        companyWebsitePlaceholder: 'www.example.com',
        linkedinUrlLabel: 'LinkedIn URL',
        linkedinUrlPlaceholder: 'www.linkedin.com/in/yourprofile',
        pdfUploadLabel: 'PDFアップロード',
        pdfUploadPlaceholder: 'PDFファイルを選択',
        uploadButton: 'アップロード',
        changeButton: '変更',
        noIndustriesFound: '一致する業界が見つかりません',
        bioLabel: '自己紹介',
        bioPlaceholder: '自己紹介と専門的な経歴を他の人に伝えてください',
        saveButton: '保存',
        analyzeButton: '分析を開始',
        aiAnalyzeButton: 'AI分析'
      },
      suppliesDemandsSection: {
        title: '供給と需要',
        whatYouCanOfferTitle: '提供できるもの',
        addNewButton: '新規追加',
        whatYouAreLookingForTitle: '求めているもの',
        previousStepButton: '前のステップ',
        saveAndContinueButton: '保存して続行'
      },
      profilePreviewSection: {
        title: 'プロフィールプレビュー',
        shareProfileButton: 'プロフィールを共有',
        whatIOfferTitle: '提供できるもの',
        whatImLookingForTitle: '求めているもの',
        noOfferingsAdded: 'まだ何も追加されていません',
        previousStepButton: '前のステップ',
        publishProfileButton: 'プロフィールを公開',
        publishSuccessfullyButton: '正常に公開されました',
        publicAndPreviewButton: '公開とプレビュー',
        publicLabel: '公開',
        privateLabel: '非公開'
      },
      editDemandDialog: {
        title: '求めているものを編集'
      },
      editSupplyDialog: {
        title: '提供できるものを編集'
      },
      addDemandDialog: {
        title: '求めているものを追加'
      },
      addSupplyDialog: {
        title: '提供できるものを追加'
      },
      editDialogCommon: {
        titleLabel: 'タイトル（オプション）',
        titlePlaceholder: 'このアイテムのタイトルを入力',
        descriptionLabel: '説明',
        descriptionPlaceholder: 'このアイテムの詳細を追加',
        cancelButton: 'キャンセル',
        saveChangesButton: '変更を保存'
      },
      addDialogCommon: {
        addItemButton: 'アイテムを追加'
      },
      // 新しいUserProfile翻訳
      visibility: {
        public: '公開',
        private: '非公開'
      },
      avatarUpload: {
        clickToChange: 'クリックして写真を変更'
      },
      sections: {
        basicInfo: '基本情報',
        servicesAndDemands: 'サービスと需要',
        contactInfo: '連絡先情報',
        description: '説明'
      },
      services: {
        title: '提供できるもの',
        titleDialog: '提供するサービス',
        noServices: 'まだサービスが追加されていません',
        addService: 'サービスを追加',
        editService: 'サービスを編集'
      },
      demands: {
        title: '求めているもの',
        titleDialog: '求めている需要', 
        noDemands: 'まだ需要が追加されていません',
        addDemand: '需要を追加',
        editDemand: '需要を編集'
      },
      form: {
        nameLabel: '名前',
        namePlaceholder: 'お名前を入力してください',
        nameRequired: '名前は必須項目です',
        jobTitleLabel: '職種',
        jobTitlePlaceholder: '職種を入力してください',
        jobTitleRequired: '職種は必須項目です',
        emailLabel: 'メール',
        emailPlaceholder: 'メールアドレスを入力してください',
        emailRequired: 'メールは必須項目です',
        phoneLabel: '電話番号',
        phonePlaceholder: '電話番号を入力してください',
        companyNameLabel: '会社名',
        companyNamePlaceholder: '会社名を入力してください',
        companyNameRequired: '会社名は必須項目です',
        locationLabel: '場所',
        locationPlaceholder: '場所を入力してください',
        companyUrlLabel: '会社ウェブサイト',
        industryLabel: '業界',
        industryPlaceholder: '業界を選択してください',
        industryRequired: '業界は必須項目です',
        industryCount: '{count} / 5 業界を選択',
        industryCountZero: '0 / 5 業界を選択',
        bioLabel: '自己紹介',
        bioPlaceholder: '自己紹介を入力してください',
        bioRequired: '自己紹介は必須項目です',
        pdfUploadLabel: 'PDFアップロード',
        pdfPlaceholder: 'PDFファイルを選択',
        uploadText: 'アップロード',
        changeText: '変更'
      },
      dialogs: {
        editProfile: 'プロフィールを編集',
        editServicesAndDemands: 'サービスと需要を編集',
        editDemand: '需要を編集',
        editService: 'サービスを編集',
        addDemand: '需要を追加',
        addService: 'サービスを追加',
        aiAnalysis: 'AI分析',
        aiTooltip: 'AIは会社名、会社ウェブサイト、アップロードされたPDFファイルに基づいて、関連するサービス需要と供給項目を智慧分析して生成します'
      },
      buttons: {
        cancel: 'キャンセル',
        save: '保存',
        saveChanges: '変更を保存',
        addItem: 'アイテムを追加',
        edit: '編集'
      },
      placeholders: {
        demandDescription: '需要の説明を入力してください',
        serviceDescription: 'サービスの説明を入力してください'
      },
      misc: {
        companyWebsite: '会社ウェブサイト',
        mobileVersionDeveloping: 'モバイル版は開発中です',
        descriptionLabel: '説明',
        pdfUploaded: 'PDFがアップロードされました'
      }
    },
    mainLayout: {
      homeBreadcrumb: 'ホーム',
      sharingBreadcrumb: '共有',
      resultsBreadcrumb: '結果',
      contentBreadcrumb: 'コンテンツ',
      myProfileBreadcrumb: 'プロフィール',
      myContactsBreadcrumb: 'コンタクト',
      emailSentBreadcrumb: '送信済みメール',
      loginButton: 'ログイン/登録',
      myProfile: 'プロフィール',
      loginError: 'ログインプロセスを完了するには、モバイルブラウザでこのページを開いてください。',
      nav: {
        matches: 'マッチング',
        myProfile: 'プロフィール',
        feedback: 'フィードバック',
        contactUs: 'お問い合わせ'
      },
      freeTrialBanner: {
        title: '現在、無料トライアル中です。',
        description: 'アップグレードしてすべての機能を解除し、トライアル終了後もプラットフォームを引き続き使用できます。',
        upgradeButton: '今すぐアップグレード'
      }
    },
    businessMatchEmailSent: {
      searchPlaceholder: '件名で検索',
      to: '宛先',
      sendTime: '送信時刻'
    },
    nonLoginBusinessMatchContent: {
      title: 'コラボレーション項目',
      matchingProcess: {
        title: 'マッチング',
        whatIsNamecardDoing: 'Namecard.aiは何をしていますか？',
        analysisDescription: 'Namecard.aiはあなたのデータを分析し、理想的なパートナーとマッチングし、接続する理由と重要な話題を提供します。'
      },
      snackbar: {
        closeButton: '閉じる'
      },
      errors: {
        openaiUnavailable: 'OpenAIサービスは現在利用できません。後でもう一度お試しください。',
        fetchMatchFailed: 'マッチングの取得でエラーが発生しました。もう一度お試しください。'
      },
      addButton: 'コラボレーション項目を追加',
      selectAllButton: 'すべて選択',
      deselectAllButton: 'すべて選択解除',
      startMatching: 'マッチングを開始',
      notCategorized: '未分類',
      originalQueryPrefix: '元のクエリ: ',
      demandLabel: '探し中',
      supplyLabel: '提供中',
      reasonPrefix: '理由: ',
      deleteDialog: {
        title: '削除確認',
        message: 'このオプションを削除してもよろしいですか？',
        cancelButton: 'キャンセル',
        confirmButton: '確認'
      },
      addDialog: {
        title: 'コラボレーション項目を追加',
        inputLabel: 'キーワードを入力してください',
        cancelButton: 'キャンセル',
        addButton: '追加'
      },
      noOptionsTitle: 'コラボレーション項目を識別できません',
      noOptionsMessage: 'システムは提供された情報から明確なコラボレーション項目を識別できませんでした。前のページに戻って、より具体的なキーワードやコンテンツを入力してください。',
      backToHomeButton: '戻って再入力',
      invalidQueryDialog: {
        title: '無効なクエリ',
        message: 'あなたのクエリは新しいコラボレーション項目を生成しませんでした。より具体的または異なるキーワードを入力してみてください。',
        confirmButton: 'OK'
      }
    },
    common: {
      progressStatus: {
        analyzingRequest: 'リクエストを分析中...',
        searchingMembers: '関連メンバーを検索中...',
        smartMatching: 'スマートマッチング中...',
        generatingResults: '結果を生成中...'
      }
    },
    pricing: {
      pageTitle: '料金プラン',
      pageSubtitle: '最適なプランをお選びください',
      currentPlanChip: {
        premiumUser: '現在プレミアムプランをご利用中です',
        freeUser: '現在無料プランをご利用中です'
      },
      freePlan: {
        title: '無料プラン',
        price: '$0',
        searchResults: '3件の検索結果'
      },
      premiumPlan: {
        title: 'プレミアムプラン',
        price: '$99',
        perMonth: '/月',
        recommendedBadge: 'おすすめ',
        searchResults: '100件の検索結果',
        showContactInfo: '推薦結果の連絡先情報を表示',
        higherExposure: 'より高い露出機会を獲得',
        freeTrialPromotion: 'プロフィールを完成させて1ヶ月のプレミアム会員資格を取得',
        goToProfileButton: 'プロフィールページへ'
      }
    },
    sharingProfile: {
      profileTitle: 'プロフィール',
      addFriendButton: '友達追加',
      addFriendSuccess: '友達追加完了',
      loginToAddFriendButton: 'ログインして連絡する'
    },
    chatRoom: {
      channels: 'チャンネル',
      members: 'メンバー',
      searchPlaceholder: 'チャンネルを検索...',
      inputPlaceholder: 'メッセージを入力...',
      selectChannelPrompt: 'チャンネルを選択してチャットを開始',
      deleteConfirmTitle: '会話を削除',
      deleteConfirmMessage: '{name}との会話を削除してもよろしいですか？',
      cancel: 'キャンセル',
      delete: '削除',
      deleteConversation: '会話を削除',
      noMessages: 'メッセージはまだありません',
      today: '今日',
      yesterday: '昨日'
    },
    nonLoginChatRoom: {
      loginPromptTitle: 'ログインしてチャットを開始',
      loginPromptMessage: 'ログインしてメッセージを送信し、ビジネスパートナーとつながりましょう。',
      loginButton: 'ログイン / 登録'
    }
  }